// 总表单 // 引入了表单控件以及可动态增减表单
<template>
  <el-form
    :inline="true"
    :model="formList.formModel"
    :rules="formList.formRules"
    :ref="formList.ref"
    :label-width="formList.labelWidth"
    @keyup.13.native="submitForm(formList.ref)"
  >
    <template v-if="formList.formData">
      <FormControl
        v-for="item in formList.formData"
        :key="item.prop"
        :controlItem="item"
        :form="formList.formModel"
        v-on="$listeners"
        :class="formList.classname"
      />
    </template>
    <template v-if="formList.dynamicValidateForm">
      <dynamicValidateForm
        :dynamicValidateForm="formList.dynamicValidateForm"
        v-on="$listeners"
        :label-width="formList.labelWidth"
      />
    </template>
    <el-form-item v-if="formList.type === 'Search'">
      <el-button
        type="primary"
        class="btn"
        @click="submitForm(formList.ref)"
        icon="el-icon-search"
        :loading="formList.loading"
        >搜索</el-button
      >
      <el-button
        style="background: #fafafa"
        @click="resetForm(formList.ref)"
        icon="el-icon-delete"
        >清空</el-button
      >
      <el-button
        class="advanced"
        v-if="!formList.advanced && formList.isAdvanced"
        icon="el-icon-arrow-down"
        @click="changeadvanced"
        >展开</el-button
      >
      <el-button
        class="advanced"
        v-else-if="formList.advanced && formList.isAdvanced"
        icon="el-icon-arrow-up"
        @click="changeadvanced"
        >收起</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import dynamicValidateForm from "@/components/Form/dynamicValidateForm";
import FormControl from "@/components/Form/FormControl.vue";
export default {
  components: { dynamicValidateForm, FormControl },
  props: {
    //   整体表单数据结构
    formList: {
      loading: false,
      // 是否需要收起展开功能
      isAdvanced: false,
      advanced: false,
      classname: "",
      // 表单作用
      type: "",
      // 表单指向
      ref: "",
      // 表单域标签的宽度
      labelWidth: "130px",
      // 表单校验规则
      formRules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ]
      },
      // 表单数据对象
      formModel: {
        phone: "",
        Company: ""
      },
      // 表单所含固定控件的数据
      formData: [
        {
          // 选择类型
          type: "Input",
          // 绑定表单
          model: "",
          // 控件名称
          label: "手机号码",
          // 控件属性名
          prop: "phone",
          // 控件子节点值
          value: [],
          // 是否可以动态增减
          isDynamic: false,
          // 控件配置
          props: {}
        }
      ],
      //可动态加减的控件数据
      dynamicValidateForm: {
        //动态表单数据对象
        dynamicItem: [
          {
            email: "",
            genal: ""
          }
        ],
        // 动态控件的数据结构
        inputItem: [
          {
            label: "邮箱",
            prop: "email",

            // 选择类型
            type: "Input",
            // 控件子节点值
            value: [],
            // 绑定表单
            model: "",
            // 是否可以动态增减
            isDynamic: true,
            // 控件配置
            props: {}
          },
          {
            label: "性别",
            prop: "genal",
            // 选择类型
            type: "Radio",
            // 控件子节点值
            value: [
              {
                label: "男",
                prop: "man"
              },
              {
                label: "女",
                prop: "woman"
              }
            ],
            // 绑定表单
            model: "",
            // 是否可以动态增减
            isDynamic: true,
            // 控件配置
            props: {}
          }
        ]
      }
    }
  },
  methods: {
    changeadvanced() {
      this.formList.advanced = !this.formList.advanced;
    },

    filterTime: time => {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      // h = h < 10 ? "0" + h : h;
      // var minute = date.getMinutes();
      // minute = minute < 10 ? "0" + minute : minute;
      // var s = date.getSeconds();
      // s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d;
      // return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    submitForm(ref) {
      // console.log(this.$refs[ref]);
      this.$refs[ref].validate(valid => {
        if (valid) {
          this.$emit("submitForm");
          return true;
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    resetForm(val) {
      this.$refs[val].resetFields();
      this.$emit("resetForm");
    },
    getDetails() {
      let time = this.filterTime(this.formList.formModel.visitTime);
      this.formList.formModel.visitTime = time;
    }
  },
  created() {
    let arr = [];
    for (const item of this.formList.formData) {
      item.props.isHiden ? "" : arr.push(item);
    }
    if (arr.length <= 5 || this.formList.classname === "isQuerySystem") {
      this.formList.isAdvanced = false;
    } else {
      this.formList.isAdvanced = true;
    }
  }
};
</script>

<style>
.btn {
  background: #5691f2;
  color: #ffffff;
}
</style>
<style scoped>
.searchControl:nth-of-type(n + 6) {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/formQuery.vue